import React from 'react';
import { Container, Typography } from '@mui/material';

export default function BeamDesign() {
  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>Steel Beam Design</Typography>
      <Typography>Module coming soon...</Typography>
    </Container>
  );
} 